module.exports = __webpack_public_path__ + "static/media/yrbTRON8 - 1 (1).ec85edf6.jpg";